import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { api } from '../api/client';
import LoadingSpinner from '../components/common/LoadingSpinner';

export default function PriceComparePage() {
  const [selectedDate, setSelectedDate] = useState(format(new Date(), 'yyyy-MM-dd'));

  const { data: priceData, isLoading } = useQuery({
    queryKey: ['prices', 'daily', selectedDate],
    queryFn: async () => {
      const response = await api.get('/prices/daily', { params: { date: selectedDate } });
      return response.data.data;
    },
  });

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">가격 비교</h1>
      </div>

      {/* Date selector */}
      <div className="card">
        <div className="flex items-center gap-4">
          <label className="label mb-0">날짜 선택</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="input w-auto"
          />
        </div>
      </div>

      {/* Price table */}
      <div className="card">
        <h2 className="text-lg font-semibold mb-4">
          {format(new Date(selectedDate), 'yyyy년 M월 d일', { locale: ko })} 가격 현황
        </h2>

        {isLoading ? (
          <LoadingSpinner className="py-8" />
        ) : priceData?.prices && priceData.prices.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    객실 타입
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    평균 판매가
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    평균 입금가
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    예약 수
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {priceData.prices.map((price: any) => (
                  <tr key={price.roomType} className="hover:bg-gray-50">
                    <td className="px-4 py-4 whitespace-nowrap font-medium">
                      {price.roomType}
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-right">
                      {price.averageSellingPrice.toLocaleString()}원
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-right">
                      {price.averageReceivedPrice.toLocaleString()}원
                    </td>
                    <td className="px-4 py-4 whitespace-nowrap text-right text-gray-500">
                      {price.reservationCount}건
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            해당 날짜에 예약 데이터가 없습니다.
          </div>
        )}
      </div>
    </div>
  );
}
